import { useStyles } from '../PrivacyPolicyPage/styles';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'hooks/useTranslation';
import { TERMS_AND_CONDITIONS } from 'pages/TermsAndConditionsPage/constants';
import { Trans } from 'react-i18next';
import React from 'react';

export const TermsAndConditionsPage = () => {
  const { t } = useTranslation('terms-and-conditions');

  const classes = useStyles();
  return (
    <>
      <div>
        <div className={classes.header}>
          <Typography className={classes.headerTitle}>{t('title')}</Typography>
          <Typography className={classes.headerSubtitle}>{t('subTitle')}</Typography>
        </div>
        <div className={classes.container}>
          <div className='mt-5 row'>
            <div className='my-3 md-order-2 col-lg-8'>
              {TERMS_AND_CONDITIONS.termsList.map(termsItem => (
                <div className={classes.termsTopic} id={termsItem.id} key={termsItem.id}>
                  <Typography className={classes.title}>
                    <Trans i18nKey={`terms-and-conditions:${termsItem.title}`} />
                  </Typography>
                  <div>
                    {termsItem.sectionList.map(sectionItem => (
                      <>
                        {sectionItem.title && <Typography>
                          <b>
                            <Trans i18nKey={`terms-and-conditions:${sectionItem.title}`} />
                          </b>
                        </Typography>}
                        {sectionItem.subList && sectionItem.subList.map((subItem, index) => (
                          <Typography key={index}>
                            <Trans i18nKey={`terms-and-conditions:${subItem}`} />
                          </Typography>
                        ))}
                      </>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
